import styled from 'styled-components';

export const AsideActions = styled.div`
  width: 250px;
  margin-left: 1em;
`;
